import e from "../managers/braze-instance.js";
import ie from "./feed-provider-factory.js";
export function getCachedFeed() {
  if (e.rr()) return ie.er().Hi();
}
